import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Accordion } from 'react-bootstrap';
import ReactDOMServer from 'react-dom/server';
import Sidebar from '../../../../Sidebar/Sidebar';
import AppLink from '../../../../../routing/helpers/AppLink';
import Translator from '../../../../components/helpers/Translator';

export default function AdvancedSearchSidebar({ activeRoute }) {
  const { moduleBridgeHex } = useParams();
  const auth = useSelector((state) => state.auth);

  return (
    <Sidebar>
      <img
        src={auth.user?.client?.logoUrl}
        className="img-fluid"
        alt={auth.user?.client?.name}
        title={auth.user?.client?.name}
      />
      <Accordion>
        <ul>
          <li
            className={`${
              activeRoute ===
              'user_module_advancedSearch_home'
                ? 'active'
                : ''
            }`}
          >
            <AppLink
              path="user_module_advancedSearch_home"
              params={{
                moduleBridgeHex,
              }}
              className="p-0"
            >
              <span className="sidebar-element">
                <span className="sb-title">Inicio</span>
              </span>
            </AppLink>
          </li>
        </ul>
      </Accordion>
    </Sidebar>
  );
}
